

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../../layouts";
import { MenuHeadsSetup } from "../../../components/RoleManagement/MenuHeadsSetup";


export const MenuHeadsSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Menu Heads"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Menu Heads", navigateTo: "/role-management/menu-heads" }
      ]}
      mainContents={<MenuHeadsSetup />}
    />
  );
};
